import { AxiosRequestConfig } from "axios";

import { addToasterActionData } from "hooks/useToasterFromActionData";

import scraperApi, { ApiError, ApiErrorResponse } from "api";
import { ActiveSubscriptionDataRouteType } from "routes/data-routes/billing-data/active-subscription/route.meta";


type RenewSubscriptionActionArgs = {
  subscriptionId: string;
  coupons?: string[];
  // `undefined` defers to the billing service's smart default, which only keeps
  // scheduled changes when the scheduled target is Enterprise / Custom / Extended
  // Trial. Callers should pass `true`/`false` only when they explicitly want to
  // override that default.
  keepScheduledChanges: boolean | undefined;
};

export const renewSubscriptionAction: (args: RenewSubscriptionActionArgs, opts?: AxiosRequestConfig) => ReturnType<NonNullable<ActiveSubscriptionDataRouteType["route"]["action"]>> =
  async ({
           subscriptionId,
           coupons,
           keepScheduledChanges
         }: RenewSubscriptionActionArgs,
         opts?: AxiosRequestConfig
  ) => {
    try {
      return {
        activeSubscription: await scraperApi.subscription.renew(subscriptionId, coupons, keepScheduledChanges, opts)
      };
    } catch (err) {
      if (err instanceof ApiError) {
        const apiError = err as ApiError<ApiErrorResponse>;

        if (apiError.error_code === "err_recently_renewed") {
          return addToasterActionData(
            { error: { message: "Your subscription was recently renewed. Please try again in about an hour." } },
            {
              toastId: "renew-recently-renewed",
              type: "error",
              title: "Resubscribe unavailable",
              description: "Your subscription was recently renewed. Please try again in about an hour."
            }
          );
        }

        return addToasterActionData(
          { error: { message: apiError.message || "There was an error resubscribing. Please try again." } },
          {
            toastId: "renew-error",
            type: "error",
            title: "Resubscribe error",
            description: apiError.message || "There was an error resubscribing. Please try again."
          }
        );
      }

      // bubble up
      throw err;
    }
  };
